// extracted by mini-css-extract-plugin
export var actionButton = "_wz-2";
export var card = "_wz-0";
export var disambiguationList = "_wz-3";
export var errorCard = "_wz-4";
export var row = "_wz-1";